import { render } from "./FeeNoticeDetail.vue?vue&type=template&id=37ad49b4&scoped=true"
import script from "./FeeNoticeDetail.vue?vue&type=script&lang=js"
export * from "./FeeNoticeDetail.vue?vue&type=script&lang=js"

import "./FeeNoticeDetail.vue?vue&type=style&index=0&id=37ad49b4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ad49b4"]])

export default __exports__